/**
 * Created by yoavp on 11/20/2014.
 */
define(function(require){
    "use strict";

    var LE = require("app");
    var Template = require("connection-templates/KPsTab/noResultsItemView.tmpl");

    var NoResultsView;
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        NoResultsView = Marionette.ItemView.extend({
            template: Template,
            className: 'no-results-view',

            ui: {
                noResultsMessage: ".no-results"
            },

            initialize: function (options) {


            },

            events: {

            },

            onRender: function() {

            }

        });
    });

    return NoResultsView;


});
